import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import InputLabel from './InputLabel'
import moment from 'moment'

interface IProps {
  name: string
  defaultDate?: moment.Moment
  label?: null | string
  error?: null | string
  required?: boolean
  disabled?: boolean
  valueFormat?: string
  onChangeHandler: (event) => void
}

const MAX_YEAR = moment().year()
const YEARS = Array.from({ length: 100 }, (_, i) => MAX_YEAR - i)
const MONTHS = Array.from({ length: 12 }, (_, i) => i + 1)

const SimpleDateInput: React.FC<IProps> = props => {
  const defaultValues = props.defaultDate
    ? {
        year: props.defaultDate.year(),
        month: props.defaultDate.month() + 1,
        day: props.defaultDate.date(),
      }
    : {
        year: MAX_YEAR - 20,
        month: 1,
        day: 1,
      }

  const [year, setYear] = React.useState(defaultValues.year)
  const [month, setMonth] = React.useState(defaultValues.month)
  const [day, setDay] = React.useState(defaultValues.day)
  const days = React.useMemo(() => {
    const maxDays = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()
    return Array.from({ length: maxDays }, (_, i) => i + 1)
  }, [year, month])

  const onChangeYear = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setYear(Number(event.target.value))
  }
  const onChangeMonth = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setMonth(Number(event.target.value))
  }
  const onChangeDay = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDay(Number(event.target.value))
  }

  React.useEffect(() => {
    props.onChangeHandler(moment(`${year}-${month}-${day}`))
  }, [year, month, day])
  return (
    <SimpleDateInputWrapper>
      {props.label && <InputLabel label={props.label} required={props.required} />}

      <div className="Simple_Date_Input_Main">
        <select className="Simple_Date_Input_Year" onChange={onChangeYear} defaultValue={year}>
          {YEARS.map(yearValue => (
            <option key={`year-input-${yearValue}`} value={yearValue}>
              {yearValue}
            </option>
          ))}
        </select>
        <div>/</div>
        <select className="Simple_Date_Input_Month" onChange={onChangeMonth} defaultValue={month}>
          {MONTHS.map(monthValue => (
            <option key={`month-input-${monthValue}`} value={monthValue}>
              {monthValue}
            </option>
          ))}
        </select>
        <div>/</div>
        <select className="Simple_Date_Input_Day" onChange={onChangeDay} defaultValue={day}>
          {days.map(dayValue => (
            <option key={`day-input-${dayValue}`} value={dayValue}>
              {dayValue}
            </option>
          ))}
        </select>

        {props.error && <span className="Simple_Date_Input_Error">{props.error}</span>}
      </div>
    </SimpleDateInputWrapper>
  )
}

const SimpleDateInputWrapper = styled.div`
  display: flex;

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }

  .Simple_Date_Input_Main {
    display: flex;
    align-items: center;
    gap: 8px;
    border: solid 1px ${constants.COLORS.divider};
    border-radius: 4px;
    padding: 8px 12px;

    > select {
      text-align: right;
      appearance: none;
      margin: 0;
      padding: 0;
      background: none transparent;
      vertical-align: middle;
      font-size: inherit;
      color: inherit;
      outline: none;
      line-height: 18px;
      border: none;

      &:disabled {
        background-color: ${constants.COLORS.divider};
      }
    }
  }

  .Simple_Date_Input_Error {
    display: block;
    margin-top: 8px;
    color: ${constants.COLORS.cautionText};
    font-size: 14px;
  }
`

export default SimpleDateInput
